import { Container } from "reactstrap";
import Header from "components/Headers/Header.js";
import { useState } from "react";
import { useGetWithdrawRequests } from "lib/api-withdraw";
import LoadingSpinner from "components/Common/LoadingSpinner";
import ErrorAlert from "components/Common/ErrorAlert";
import NotificationAlert from "components/Common/NotificationAlert";
import WithdrawStatsCards from "components/Withdraw/WithdrawStatsCards";
import WithdrawTable from "components/Withdraw/WithdrawTable";

const Withdraw = () => {
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        color: "",
        duration: 3000,
    });

    const {
        data: withdrawRequestsResponse,
        isLoading,
        isError,
        error,
        refetch,
    } = useGetWithdrawRequests();

    const showAlert = (message, color, duration = 3000) => {
        setAlert({ show: true, message, color, duration });
    };

    const hideAlert = () => {
        setAlert({ show: false, message: "", color: "" });
    };

    const withdrawRequestsData = withdrawRequestsResponse || [];

    if (isLoading) {
        return (
            <>
                <Header />
                <LoadingSpinner message="Loading withdraw requests..." />
            </>
        );
    }

    if (isError) {
        return (
            <>
                <Header />
                <ErrorAlert error={error} onRetry={refetch} />
            </>
        );
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <NotificationAlert alert={alert} onClose={hideAlert} />

                <WithdrawStatsCards withdrawData={withdrawRequestsData} />

                <WithdrawTable
                    withdrawData={withdrawRequestsData}
                    onRefresh={refetch}
                    showAlert={showAlert}
                />
            </Container>
        </>
    );
};

export default Withdraw;
